import { selectActivePeriod } from '../publishTerms';
import { createSelector } from 'reselect';

export interface IDiffPricingIds {
  diffPriceId: number;
  diffPriceIterationId: string;
  diffPriceGranuleGuid: string;
}

export const selectAnalyticsDiffPricingIds = createSelector(
  [selectActivePeriod],
  (activePeriod): IDiffPricingIds | null => {
    if (!activePeriod) {
      return null;
    }

    const { diffPriceId, diffPriceIterationId, diffPriceGranuleGuid } = activePeriod.tariffIdentificator;

    const isSomeParamsPresent = [diffPriceId, diffPriceIterationId, diffPriceGranuleGuid].some(Boolean);

    if (isSomeParamsPresent) {
      return {
        diffPriceId,
        diffPriceIterationId,
        diffPriceGranuleGuid,
      };
    }

    return null;
  },
);
